import React, { Component } from 'react';
import { FlatList, View, ActivityIndicator } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as pedidosActions } from '../../store/ducks/pedidos';
import { Creators as pedidoSelecionadoActions } from '../../store/ducks/pedido-selecionado';

import { getDataHoraAtual } from './api';

import EmptyState from './emptyState';

import ItemLista from './itemLista';

import styles from './styles';

const ID_STATUS_AGUARDANDO = 1,
    ID_STATUS_RECEBIDO = 2;

class ListaPedido extends Component {
    state = {
        loading: true,
        selectedItem: {},
        dhAtual: ''
    };

    async componentDidMount() {
        const { idStatusPedido = null, searchPedidos } = this.props;

        await searchPedidos({ idStatusPedido });
        const dhAtual = await getDataHoraAtual();

        this.setState({
            ...this.state,
            loading: false,
            dhAtual
        });
    }

    showDetalhe = (selectedItem) => {
        const { selectPedido } = this.props;

        if (selectedItem.idStatusPedido === ID_STATUS_AGUARDANDO) {
            selectedItem.idStatusPedido = ID_STATUS_RECEBIDO;
        }

        this.setState({ ...this.state, selectedItem });
        selectPedido(selectedItem);
    };

    renderList = () => {
        const {
                pedidos = {},
                showOrderCounter,
                isHistorico = false
            } = this.props,
            { list = {} } = pedidos,
            { data = [], dhAtual = this.state.dhAtual } = list;

        return (
            <FlatList
                data={data}
                renderItem={({ item }) => (
                    <ItemLista
                        isHistorico={isHistorico}
                        item={item}
                        dhAtual={dhAtual}
                        showDetalhe={this.showDetalhe}
                        showOrderCounter={showOrderCounter}
                    />
                )}
                ListEmptyComponent={() => this.emptyState()}
                keyExtractor={(item, index) =>
                    `pedido-${item.idPedido}-${index}`
                }
            />
        );
    };

    render() {
        const { loading } = this.state;

        return (
            <View style={styles.container}>
                {loading ? (
                    <ActivityIndicator style={styles.loading} size="large" />
                ) : (
                    this.renderList()
                )}
            </View>
        );
    }

    emptyState = () => {
        return <EmptyState />;
    };
}

const mapStateToProps = ({ pedidoSelecionado, pedidos }) => ({
    pedidoSelecionado,
    pedidos
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...pedidoSelecionadoActions, ...pedidosActions },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ListaPedido);
